import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import useFetch from "./helpers/useFetch";
import { PageHeaderLink } from "./helpers/elements";
import { useDeviceWidth } from "./useDeviceWidth";
import axios from "axios";

const UpdateAppScreenshotNew = (props) => {
    const { appNameId } = useParams();
    const { windowWidth, screenWidth, deviceWidthEnum } = useDeviceWidth();
    const [appData] = useFetch(`${process.env.REACT_APP_BASE_URL}/app/${appNameId}/`);
    const [isSubmit, setIsSubmit] = useState(false);
    const [appScreenshotNew, setAppScreenshotNew] = useState([]);
    const [appScreenshotNewPreview, setAppScreenshotNewPreview] = useState([]);
    const [updateAppScreenshotNewResponseData, setUpdateAppScreenshotNewResponseData] = useState({});

    useEffect(() => {
        if (appScreenshotNewPreview.length < 4) {
            setAppScreenshotNewPreview(
                appScreenshotNew?.map((file) => URL.createObjectURL(file))
            );
        }
    }, [appScreenshotNew]);

    const handleAppScreenshotNewSelect = (event) => {
        const files = Array.from(event.target.files);
        setAppScreenshotNew(files);
        // setAppScreenshotNewPreview(
        //     files.map((file) => URL.createObjectURL(file))
        // );
    };

    const showLoadingState = (e) => {
        setIsSubmit(true);
    };

    const handleScreenshotSave = (event) => {
        event.preventDefault();
        const formData = new FormData();
        appScreenshotNew.forEach((file, index) => {
            // formData.append(`images[${index}]`, file)
            formData.append(`screenshots`, file)
        });
        const updateAppURL = `${process.env.REACT_APP_BASE_URL}/app/${appNameId}/`;
        const headers = {
            'Accept': '*/*',
            // 'Origin': '*',
            'Authorization': `Bearer ${window.localStorage.getItem('nine_login')}`
        };
        const fetchConfig = {
            method: 'PATCH',
            headers: headers,
            mode: 'cors',
            // body: formData,
            data: formData,
            cache: 'default',
        };
        // fetch(updateAppURL, fetchConfig)
        axios(updateAppURL, fetchConfig)
            .then(response => {
                if (response.status !== 200) throw response;
                // return response.json()
                return response.data
            })
            .then(data => {
                setIsSubmit(false);
                setUpdateAppScreenshotNewResponseData({
                    message: "Screenshot upload successful",
                    successful: true,
                    error: false
                });
                setTimeout(() => window.history.back(), 800);
            })
            .catch((error) => {
                // let error_message;
                // if (error.status === 401) {
                //     error_message = "Kindly login to update your Profile"
                // } else if (error.status === 400) {
                //     error_message = "Unable to perform update. Kindly fix any form errors and re-submit"
                // } else if (error.status === 500) {
                //     error_message = "Check your internet connection"
                // } else {
                //     // There is no network connection or the Server is not up.
                //     error_message = "We couldn't upload your screenshot. Kindly retry"
                // }
                const errorMessage = error.response?.data.error || "Unable to process request";
                setUpdateAppScreenshotNewResponseData({
                    message: errorMessage,
                    successful: false,
                    error: true
                });
                // reset the isSubmit loader
                setIsSubmit(false);
            });

    };
    return (
        <section className={"flex flex-row flex-nowrap justify-start dark:bg-111314"}>
            {
                windowWidth >= deviceWidthEnum.laptop
                    ? <section className={"pct:w-20 vh:h-100 bg-lighter dark:bg-000304 dark:every:color-whitesmoke"}>
                        <div
                            className={"flex flex-column justify-center align-items-start font-18 lh-normal pct:w-100 h-160 pad-x4 lg:font-24"}>
                            <div className={"font-size-inherit"}>Update</div>
                            <div className={"font-size-inherit font-bold color-gray"}>{appData?.name}</div>
                        </div>
                        <section className={"d-block every:d-block|pad-4|radius|decoration-none|color-initial hover:every:bg-light dark:every:color-whitesmoke dark:hover:every:bg-222425"}>
                            {/*<button className={"pct:w-100 text-left border-0 bg-initial cursor-pointer"} onClick={() => {window.history.back()}}>View Screenshots</button>*/}
                            <Link to={`${window.location.pathname.split("/").slice(0, window.location.pathname.split("/").length - 1).join("/")}/`}>View Screenshots</Link>
                        </section>
                    </section>
                    : null
            }
            <form encType={"multipart/form-data"} onSubmit={handleScreenshotSave} className={"pct:w-100 lg:pct:w-56|mg-r-auto|mg-t8"}>
                <PageHeaderLink />
                <section className={""}>
                    {/*<header className={"pad-x2 font-semibold h-5 lh-5"}>*/}
                    {/*    /!*Upload ScreenshotNews of your app*!/*/}
                    {/*    /!*<span className={"d-block font-italic"}>You could upload this later</span>*!/*/}
                    {/*</header>*/}
                    {
                        updateAppScreenshotNewResponseData?.successful
                            ? <div
                                className="relative mg-x-auto text-center pct:w-64 pad-x2 pad-y2 radius-sm bg-green-inverse color-green">
                                {updateAppScreenshotNewResponseData.message}
                            </div>
                            : null
                    }
                    {
                        updateAppScreenshotNewResponseData?.error
                            ? <div
                                className="relative mg-x-auto text-center pct:w-64 pad-x2 pad-y2 radius-sm bg-red-inverse color-red">
                                {updateAppScreenshotNewResponseData.message}
                            </div>
                            : null
                    }
                    <section className={"pad-t4 pad-b2 bg-white-solid dark:bg-111314"}>
                        {
                            appScreenshotNewPreview?.length < 1
                                ? <label
                                    htmlFor={"id-app-screenshot-upload"}
                                    className={"flex flex-column justify-center align-items-center pct:w-80 pct:max-w-80 h-480 mg-x-auto text-center border:2px_dashed_DDD radius color-999 hover:cursor-pointer dark:bg-222425 dark:border:0px_solid_darkgray dark:hover:bg-333435"}>
                                    <span className="fa fa-plus font-28 pad-y2"></span>
                                    <input
                                        id={"id-app-screenshot-upload"}
                                        type="file"
                                        name={"screenshot"}
                                        hidden
                                        accept={"image/*"}
                                        multiple
                                        onChange={handleAppScreenshotNewSelect}
                                    />
                                </label>
                                : <>
                                    <img src={appScreenshotNewPreview[0]}
                                        alt={"new Screenshot"}
                                        height={"480"}
                                        // width={"80%"}
                                        className={"d-block pct:w-80 pct:max-w-80 mg-x-auto radius object-cover object-center"}
                                    />
                                    <label
                                        htmlFor={"id-app-screenshot-upload"}
                                        className={"flex flex-row justify-center align-items-center pct:w-80 pct:max-w-80 mg-x-auto mg-y4 text-center border:1px_dashed_BBB radius color-999 dark:border:0px_solid_darkgray"}>
                                        <span className="fa fa-plus pad-2"></span>
                                        <div>{"Select another image"}</div>
                                        <input
                                            id={"id-app-screenshot-upload"}
                                            type="file"
                                            name={"screenshot"}
                                            hidden
                                            accept={"image/*"}
                                            multiple
                                            onChange={handleAppScreenshotNewSelect}
                                        />
                                    </label>
                                </>
                        }
                        <div
                            className={"flex flex-row flex-nowrap justify-center pct:w-80 mg-x-auto mg-y2 pad-x1 bg-white-solid every:pct:w-25|h-96|mg-y2|pad-x1|bg-lighter|radius-sm dark:bg-111314 dark:every:bg-222425"}>
                            {
                                appData?.screenshot?.length > 0
                                    ? appData?.screenshot.map((screenshot_obj, index) => (
                                        <>
                                            <Link
                                                to={`${window.location.pathname.split("/").slice(0, window.location.pathname.split("/").length - 1).join("/")}/${screenshot_obj?.id}`}
                                                key={index}
                                                className={"pad-x-2 radius-inherit"}>
                                                <img src={screenshot_obj?.image}
                                                    alt={`screenshot preview ${index}`}
                                                    height={"100%"}
                                                    className={"pct:max-w-100 pct:w-100 object-cover object-center radius-inherit"} />
                                            </Link>
                                            {/*<div className={"abs bottom-0 pct:w-100 bg-transparent"}></div>*/}
                                        </>
                                    ))
                                    : null
                            }
                        </div>
                    </section>
                    <div className={"fixed bottom-0 flex flex-column flex-nowrap justify-center align-items-center pct:w-100 mg-x-auto mg-t-2 pad-y2 border:0px_solid_lightgray border-t-2 bg-white-solid every:h-7|lh-7|mg-x1|mg-y1|radius|text-center lg:pct:w-56|border-0 dark:bg-inherit"}>
                        <button
                            type={"submit"}
                            className={"pct:w-60 border-0 bg-green color-white disabled:bg-green-inverse"}
                            onClick={showLoadingState}
                            disabled={appScreenshotNew.length < 1}
                        >
                            {isSubmit ? <span className='fa fa-spinner fa-spin'></span> : "Save"}
                        </button>
                    </div>
                </section>
            </form>
        </section>
    )
}

export default UpdateAppScreenshotNew;